import React from "react";
import {Translation as T} from "@awe-web/shared/lib";
import {ScreenSection, ScreenHeading} from "../../components/screen.js";
import {TypeArea} from "../../components/layout.js";
import {B2bPromotion} from "../../promotion/components/promotion";
import SelectStationAndTime from "../../stations/components/select_station_and_time.jsx";

const HEADING = "ALG0000001";

export default function B2B_SelectStationAndTime() {
  return (
    <div className="b2b-ltr-select-period">
      <ScreenSection main dark>
        <TypeArea>
          <ScreenHeading><T code={HEADING} /></ScreenHeading>
          <SelectStationAndTime reservationPath="B2B" />
        </TypeArea>
      </ScreenSection>

      <ScreenSection light>
        <TypeArea>
          <B2bPromotion />
        </TypeArea>
      </ScreenSection>
    </div>
  );
}